export default function CircleThumb({ src = null, className = null }) {
    return (
        <div className={className}>
            <img className="circle-thumb" alt="" src={ src || 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+PGNpcmNsZSBjeD0iMjUiIGN5PSIyNSIgcj0iMjUiIGZpbGw9InNpbHZlciIgLz48L3N2Zz4=' } />
        </div>
    );
}